import $ from 'jquery';
import elements from 'aos/src/js/helpers/elements';

$(document).ready(function () {
    $('body').on('mouseenter', '.hover-effect li a', function () {
        $(this).removeClass('active');
        $(this).parent('li').siblings('li').children('a').addClass('active');
    });

    $('body').on('mouseleave', '.hover-effect', function () {
        $('li a', this).removeClass('active');
    });

    setLogoState();
});
